export default __webpack_public_path__ + "static/media/Brand_Mark.4543c78d.png";